import moment from "moment";
import React, { useEffect, useState } from "react";
import { useRegistrarAcordoContext } from "..";
import SpinnerUAU from "../../../../../Components/Loding/SpinnerUAU";
import {
    DataTable,
    IDataTableColumn,
} from "../../../../../Components/Table/DataTable";
import { IParcelaBoletos } from "../../../../../Interfaces/Cobranca/ParcelasAbertas/ParcelasAbertas";

export default function ParcelasEscolhidas() {
    const { lstParcelasSelecionadasComDescontos, calcularDescontos } =
        useRegistrarAcordoContext();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!lstParcelasSelecionadasComDescontos) {
            setLoading(true);
            calcularDescontos({
                descontoFinanceiro: 0,
                descontoJurosPercentual: 0,
                descontoMultaPercentual: 0,
                descontoPercentual: 0,
                honorarioFinanceiro: 0,
                honorarioPercentual: 0,
            }).finally(() => setLoading(false));
        }
    }, [lstParcelasSelecionadasComDescontos, calcularDescontos]);

    return (
        <div>
            {loading ? (
                <SpinnerUAU />
            ) : (
                lstParcelasSelecionadasComDescontos && (
                    <DataTable
                        data={lstParcelasSelecionadasComDescontos}
                        keyField={"ID_CHAVE_PARCELA"}
                        columns={columnsDataTable}
                        bordered={false}
                        rowClasses="border-bottom border-gray checkbox-table"
                        sizePerPage={lstParcelasSelecionadasComDescontos.length}
                        wrapperClasses="y-scroll maxHeight-300"
                        noPagination
                        noSearch
                        defaultTableCellClasses={(c, row) =>
                            `p-3 ws-nowrap ${
                                new Date(row.Data_Prc).getTime() < Date.now()
                                    ? "text-danger"
                                    : ""
                            }`
                        }
                        customs={[
                            {
                                name: "date-venc",
                                wrapperFormatter: (c, row) => (
                                    <span
                                        className={`label label-light-${
                                            new Date(row.Data_Prc).getTime() <
                                            Date.now()
                                                ? "danger"
                                                : "primary"
                                        } label-inline mr-2 my-1`}
                                    >
                                        {moment(row.Data_Prc).format(
                                            "DD/MM/yy"
                                        )}
                                    </span>
                                ),
                            },
                        ]}
                        cardRows={[
                            {
                                key: "header",
                                justify: "between",
                            },
                            {
                                key: "financeiro",
                                justify: "evenly",
                            },
                        ]}
                    />
                )
            )}
        </div>
    );
}

const columnsDataTable: Array<IDataTableColumn<IParcelaBoletos>> = [
    {
        dataField: "Tipo_Prc",
        text: "Parcela",
        formatter: (c, row) => `${row.Tipo_Prc} - ${row.NumParc_Prc}`,
        cardCustomFormatter: (c) => (
            <span className="font-weight-bolder">{c}</span>
        ),
        cardRow: "header",
    },
    {
        dataField: "Data_Prc",
        text: "Data de Vencimento",
        formatoPadrao: "date",
        cardCustomPadrao: "date-venc",
        cardRow: "header",
    },
    {
        dataField: "ValorReaj",
        text: "Valor Reajus.",
        formatoPadrao: "money",
        cardRow: "financeiro",
    },
    {
        dataField: "Valor_Prc",
        text: "Valor Principal",
        formatoPadrao: "money",
        cardRow: "financeiro",
    },
    {
        dataField: "ValorMulta",
        text: "Multa",
        formatoPadrao: "money",
        cardRow: "financeiro",
    },
    {
        dataField: "vlrJurosAtraso",
        text: "Juros",
        formatoPadrao: "money",
        cardRow: "financeiro",
    },
    {
        dataField: "vlrHonorario",
        text: "Honorário",
        formatoPadrao: "money",
        cardRow: "financeiro",
    },
    {
        dataField: "vlrDescontoMulta",
        text: "Desconto Multa",
        formatoPadrao: "money",
        cardRow: "financeiro",
    },
    {
        dataField: "vlrDescontoJuros",
        text: "Desconto Juros",
        formatoPadrao: "money",
        cardRow: "financeiro",
    },
    {
        dataField: "vlrDesconto",
        text: "Desconto",
        formatoPadrao: "money",
        cardRow: "financeiro",
    },
    {
        dataField: "vlrTotalComDesconto",
        text: "Total",
        formatoPadrao: "money",
        cardRow: "financeiro",
    },
];
